import Configuracao from '../util/Configuracao';
import Api from './Api';

/**
 * Classe utilizada para acessar os webservices
 */
class ProcessoApi extends Api {
    votacao = [];

    /**
     * [FIXME]
     * @param {string | number | undefined} idProcesso
     */
    // eslint-disable-next-line no-unused-vars
    recuperarPreVotacao(idProcesso) {
        return [
            { tipo: 'Convergente', quantidade: 2 },
            { tipo: 'Convergente com Ressalva', quantidade: 1 },
            { tipo: 'Divergente', quantidade: 0 }
        ];
    }

    async recuperarVotacaoMagistrado(idProcesso, siglaMagistrado) {
        //let votacao = localStorage.getItem('SE-votacao');
        if (!this.votacao) {
            return;
        }

        //votacao = await JSON.parse(votacao);
        const votoMagistrado = this.votacao.find((voto) => {
            return voto.numeroCompleto.includes(idProcesso) && voto.magistrado.includes(siglaMagistrado);
        });
        return votoMagistrado;
    }

    async marcarTranscendencia(idSessao, numeroProcesso) {
        const body = {};
        return this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/transcendencia',
            'POST',
            body
        );
    }

    async desmarcarTranscendencia(idSessao, numeroProcesso) {
        return this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/transcendencia',
            'DELETE'
        );
    }

    async bloquearBaixa(idSessao, numeroProcesso) {
        return this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/bloqueio-baixa-automatica',
            'POST',
            {}
        );
    }
    async desbloquearBaixa(idSessao, numeroProcesso) {
        return this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/bloqueio-baixa-automatica',
            'DELETE'
        );
    }

    async recuperarInfoTranscendenciaBloqueioBaixa(idSessao, numeroProcesso) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/indicadores-processo'
        );
        return result.data;
    }

    async salvarVotoMagistrado(idProcesso, siglaMagistrado, votoMagistrado) {
        const voto = {
            numeroCompleto: idProcesso,
            magistrado: siglaMagistrado,
            voto: votoMagistrado
        };

        //let votacao = await JSON.parse(localStorage.getItem('SE-votacao'));
        if (!this.votacao || this.votacao.length === 0) {
            this.votacao = [voto];
        } else {
            let isAchou = false;
            const votoMagistrado = this.votacao.map((votoRegistrado) => {
                if (
                    votoRegistrado.numeroCompleto.includes(idProcesso) &&
                    votoRegistrado.magistrado.includes(siglaMagistrado)
                ) {
                    votoRegistrado = voto;
                    isAchou = true;
                }
                return votoRegistrado;
            });

            if (!isAchou) {
                votoMagistrado.push(voto);
            }
            this.votacao = votoMagistrado;
        }
        //localStorage.setItem('SE-votacao', JSON.stringify(votacao));
    }

    async recuperarDetalhesProcessoSessao(numeroProcesso, idSessaoJulgamento) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessaoJulgamento + '/processos/' + numeroProcesso + '/detalhes'
        );
        return result.data;
    }

    async recuperarDetalhesProcesso(numeroProcesso, origem, tratamentoErroComponente) {
        const resultado = await this.fetchConfig({
            url: this.configuracao.urlProcessos + '/' + numeroProcesso + '/detalhes?origem=' + origem,
            tratamentoErroComponente: tratamentoErroComponente
        });
        return resultado;
    }

    async recuperarEmentaDecisao(numeroProcesso, idSessaoJulgamento) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessaoJulgamento + '/processos/' + numeroProcesso + '/ementa-decisao'
        );
        return result.data;
    }

    async recuperarPlanilha(numeroProcesso) {
        const result = await this.fetch(this.configuracao.urlBaseSessao + '/planilha/' + numeroProcesso);
        return result.data;
    }

    async recuperarConteudoVoto(numeroProcesso, idSessaoJulgamento) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessaoJulgamento + '/processos/' + numeroProcesso + '/voto-relator',
            'GET',
            undefined,
            [{ parametro: 'accept', valor: 'text/html' }]
        );
        return result.data;
    }

    async recuperarEditorVoto(numeroProcesso, idSessaoJulgamento) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessaoJulgamento + '/processos/' + numeroProcesso + '/editor-minuta'
        );
        return result.data;
    }

    async recuperarConteudoAcordaoAssinado(numeroProcesso, idSessaoJulgamento) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessaoJulgamento + '/processos/' + numeroProcesso + '/acordao-assinado',
            'GET',
            undefined,
            [{ parametro: 'accept', valor: 'text/html' }]
        );
        return result.data;
    }

    async recuperarTiposResultadosJulgamento() {
        const result = await this.fetch(this.configuracao.urlTiposResultadosJulgamentos);
        return result.data;
    }

    async recuperarDecisoesProcessuais() {
        const result = await this.fetch(this.configuracao.urlDecisoesProcessuais);
        return result.data;
    }

    async recuperarMovimentosProcessuais() {
        const result = await this.fetch(this.configuracao.urlMovimentosProcessuaisJulgamento);
        return result.data;
    }

    async recuperarMovimentosProcesso(idSessao, numeroProcesso) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/movimentos'
        );
        return result.data;
    }

    async recuperarMovimentosGabinete(idSessao, numeroProcesso) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/movimentos-gabinete'
        );
        return result.data;
    }

    async recuperarConteudoDocumento(idSessao, numeroProcesso, tipoArquivo, idDocumento) {
        const result = await this.fetchConfig({
            url:
                this.configuracao.urlDocumentos +
                idSessao +
                '/' +
                numeroProcesso +
                '/' +
                idDocumento +
                '/' +
                tipoArquivo +
                '/conteudo',
            addHeader: [{ parametro: 'accept', valor: 'application/octet-stream, text/html' }],
            responseType: 'arraybuffer'
        });
        const conteudo = await result.data;
        return conteudo;
    }

    /**
     * Retorna um array com o número sequencial de apregoamento de cada processo apreciado.
     *
     * @param {*} numerosProcessos
     * @param {*} idSessao
     * @param {*} tipoResultadoJulgamento
     * @returns
     */
    async registrarJulgamento(numerosProcessos, idSessao, tipoResultadoJulgamento, tratamentoErroComponente, vistas) {
        const body = {
            numerosProcessos: numerosProcessos,
            resultadoJulgamento: {
                tipo: tipoResultadoJulgamento
            }
        };

        if (vistas) {
            body.magistradosVistaRegimental = vistas;
        }

        const response = await this.fetchConfig({
            url: `${this.configuracao.urlSessoes + idSessao}/resultados-julgamentos`,
            method: 'PUT',
            data: body,
            tratamentoErroComponente: tratamentoErroComponente
        });

        return response;
    }

    async salvarVistaRegimental(pedidos, idSessao, processo) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/vista-regimental`;
        await this.fetch(url, 'PUT', pedidos);
    }

    async removerVistaRegimental(idSessao, processo) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${processo}/vista-regimental`;
        await this.fetch(url, 'DELETE', [], [{ parametro: 'Content-type', valor: 'application/json' }]);
    }

    async gravarDecisao(idSessao, numeroProcesso, idDecisao) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${numeroProcesso}/decisao`;
        await this.fetch(url, 'PUT', { id: idDecisao });
    }

    async gravarDecisaoLote(idSessao, numeroProcesso, idDecisao) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${numeroProcesso}/decisao`;
        return this.fetchConfig({
            url: url,
            method: 'PUT',
            data: { id: idDecisao },
            tratamentoErroComponente: true
        });
    }

    async gravarComposicaoProcesso(idSessao, numeroProcesso, composicao) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${numeroProcesso}/composicao-processo`;
        return this.fetch(url, 'PUT', composicao);
    }

    async gravarComposicaoLote(idSessao, numerosProcessos, composicao, manterImpedimentosComposicao) {
        let url = `${this.configuracao.urlSessoes + idSessao}/composicoes-processo`;
        url += manterImpedimentosComposicao ? '?manterImpedimentosComposicao=true' : '';

        return this.fetchConfig({
            url: url,
            method: 'PUT',
            data: { numerosProcessos: numerosProcessos, magistrados: composicao },
            tratamentoErroComponente: true
        });
    }

    async gravarProcuradorLote(idSessao, numerosProcessos, procurador) {
        const url = `${this.configuracao.urlSessoes + idSessao}/procuradores`;
        return this.fetchConfig({
            url: url,
            method: 'PUT',
            data: { numerosProcessos: numerosProcessos, procurador: procurador },
            tratamentoErroComponente: true
        });
    }

    async excluirDecisao(idSessao, numeroProcesso) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${numeroProcesso}/decisao`;
        await this.fetch(url, 'DELETE');
    }

    async recuperarDecisao(idSessao, numeroProcesso) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${numeroProcesso}/decisao`;
        const resultado = await this.fetch(url);
        return resultado.data;
    }

    /**
     * O serviço apaga todos os movimentos e grava o que foi passado, sendo necessário enviar todos os movimentos com complementos.
     *
     * @param {*} idSessao
     * @param {*} numeroProcesso
     * @param {*} movimentos
     */
    async gravarMovimentos(idSessao, numeroProcesso, movimentos) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${numeroProcesso}/movimento-cnj`;
        await this.fetch(url, 'PUT', movimentos);
    }

    /**
     * Grava os movimentos com tratamento de erro pelo componente de registro em lote.
     *
     * @param {string} idSessao
     * @param {string|number} numeroProcesso
     * @param {*} movimentos
     * @returns
     */
    async gravarMovimentosLote(idSessao, numeroProcesso, movimentos) {
        const url = `${this.configuracao.urlSessoes}${idSessao}/processos/${numeroProcesso}/movimento-cnj`;

        return this.fetchConfig({
            url: url,
            method: 'PUT',
            data: movimentos,
            tratamentoErroComponente: true
        });
    }

    async editarNomeAdvogadoSustentacaoOral(idSessao, numeroProcesso, nomeAdvogadoAnterior, nomeAdvogadoNovo) {
        // O endpoint pedidos-sustentacao-oral nao existe no backend. Verificar se esse codigo esta inacessivel
        const url = `${this.configuracao.urlSessoes}${idSessao}/processos/${numeroProcesso}/pedidos-sustentacao-oral`;

        await this.fetch(url, 'PUT', {
            nomeAdvogadoAnterior: nomeAdvogadoAnterior ? nomeAdvogadoAnterior.nome : null,
            nomeAdvogadoNovo: nomeAdvogadoNovo
        });
    }

    async incluirAdvogadoSustentacaoOral(idSessao, numeroProcesso, nomeAdvogadoNovo, codigoParte) {
        const url = `${this.configuracao.urlSessoes}${idSessao}/processos/${numeroProcesso}/representantes?sistemaInscricao=${Configuracao.ID_SISTEMA}`;

        await this.fetch(url, 'POST', {
            codigoParte: codigoParte,
            representante: {
                nome: nomeAdvogadoNovo,
                genero: 'M'
            }
        });
    }

    async registrarPresencaAdvogadoProcesso(idSessao, numeroProcesso, advogado, notificarClientes) {
        const regOAB = advogado.advogado.regOAB;
        const paramLetra = regOAB.letra ? `-${regOAB.letra}` : '';
        const url = `${this.configuracao.urlSessoes}${idSessao}/processos/${numeroProcesso}/representantes/${regOAB.numero}-${regOAB.siglaUf}${paramLetra}?sistemaInscricao=${Configuracao.ID_SISTEMA}&notificarClientes=${notificarClientes}`;
        const result = await this.fetch(url, 'PUT', advogado);
        return result.data;
    }

    async recuperarAlertasImpedimento(idSessao, numeroProcesso) {
        const url = `${this.configuracao.urlSessoes + idSessao}/processos/${numeroProcesso}/impedimentos`;
        const result = await this.fetch(url);
        return result.data;
    }

    async recuperarObservacaoVoto(idSessao, numeroProcesso, tipoObservacao, siglaMagistrado) {
        const result = await this.fetch(
            this.configuracao.urlSessoes +
                idSessao +
                '/processos/' +
                numeroProcesso +
                '/observacoes/' +
                tipoObservacao +
                '/' +
                siglaMagistrado
        );
        return result.data;
    }

    async recuperarObservacaoVotoPeloId(idSessao, numeroProcesso, tipoObservacao, siglaMagistrado, idObservacao) {
        const result = await this.fetch(
            this.configuracao.urlSessoes +
                idSessao +
                '/processos/' +
                numeroProcesso +
                '/observacoes/' +
                tipoObservacao +
                '/' +
                siglaMagistrado +
                '/' +
                idObservacao
        );
        return result.data;
    }

    async recuperarConteudoObservacaoVotoPeloId(idSessao, numeroProcesso, tipoObservacao, siglaMagistrado, idConteudo) {
        const result = await this.fetch(
            this.configuracao.urlSessoes +
                idSessao +
                '/processos/' +
                numeroProcesso +
                '/observacoes/' +
                tipoObservacao +
                '/' +
                siglaMagistrado +
                '/' +
                idConteudo +
                '/conteudo'
        );
        return result.data;
    }

    async alterarIndicacaoTipoJulgamento(origem, numeroProcesso, tipoJulgamento) {
        const result = await this.fetch(
            this.configuracao.urlProcessos + '/' + numeroProcesso + '/indicacao-tipo-julgamento?origem=' + origem,
            'PUT',
            tipoJulgamento,
            [{ parametro: 'Content-type', valor: 'text/plain' }]
        );
        return result.data;
    }

    async alterarTipoJulgamento(idSessao, numeroProcesso, tipoJulgamento) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/tipo-julgamento',
            'PUT',
            tipoJulgamento,
            [{ parametro: 'Content-type', valor: 'text/plain' }]
        );
        return result.data;
    }

    async alterarTipoJulgamentoLote(idSessao, numerosProcessos, tipoJulgamento) {
        return this.fetchConfig({
            url: this.configuracao.urlSessoes + idSessao + '/tipo-julgamento',
            method: 'PUT',
            data: { tipoJulgamento: tipoJulgamento, numerosProcessos: numerosProcessos },
            tratamentoErroComponente: true
        });
    }

    async remeterParaPresencial(idSessao, numeroProcesso, motivo) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/presencial/processos/' + numeroProcesso,
            'PUT',
            { complemento: motivo }
        );
        return result.data;
    }

    async remeterParaSessaoFutura(idSessao, numeroProcesso, idTipoRemessa, motivo) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/futura/processos/' + numeroProcesso,
            'PUT',
            {
                tipo: { id: idTipoRemessa },
                complemento: motivo
            }
        );
        return result.data;
    }

    async recuperarMotivoRemessaPresencial(idSessao, numeroProcesso) {
        const result = await this.fetch(
            this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/motivo-remessa-presencial'
        );
        return result.data;
    }

    async incluirProcessoEmPauta(
        idPauta,
        numeroProcesso,
        tipoInclusao,
        tipoJulgamento,
        prepraracaoPauta,
        tratamentoErroComponente
    ) {
        const url =
            this.configuracao.urlSessoes +
            idPauta +
            '/processos/' +
            numeroProcesso +
            (tipoInclusao ? '?tipoInclusao=' + tipoInclusao : '') +
            (tipoJulgamento ? '&tipoJulgamento=' + tipoJulgamento : '') +
            (prepraracaoPauta === true ? '&preparacaoPauta=' + true : '');
        return this.fetchConfig({ url: url, method: 'PUT', tratamentoErroComponente: tratamentoErroComponente });
    }

    async removerProcessoPauta(idPauta, numeroProcesso, tratamentoErroComponente) {
        const url = this.configuracao.urlSessoes + idPauta + '/processos/' + numeroProcesso;
        return this.fetchConfig({ url: url, method: 'DELETE', tratamentoErroComponente: tratamentoErroComponente });
    }

    async recuperarProcessoPautavel(idPauta, numeroProcesso, tratamentoErroComponente) {
        const response = await this.fetchConfig({
            url: this.configuracao.urlPautas + '/' + idPauta + '/processos-pautaveis/' + numeroProcesso,
            tratamentoErroComponente: tratamentoErroComponente
        });
        return tratamentoErroComponente ? response : response.data;
    }

    async liberarProcessoGabinete(idSessao, numeroProcesso) {
        return this.fetchConfig({
            url: this.configuracao.urlSessoes + idSessao + '/processos/' + numeroProcesso + '/liberar-para-gabinete',
            method: 'POST',
            tratamentoErroComponente: true
        });
    }

    async recuperarUrlEdicaoVoto(idSessao, numeroProcesso, identificadorEdicaoVoto) {
        const result = await this.fetch(
            this.configuracao.urlSessoes +
                idSessao +
                '/processos/' +
                numeroProcesso +
                '/url-edicao/' +
                encodeURIComponent(identificadorEdicaoVoto)
        );
        return result.data;
    }

    async recuperarJulgamentosAnteriores(numeroCompleto, origem) {
        const response = await this.fetchConfig({
            url: this.configuracao.urlProcessos + '/' + numeroCompleto + '/julgamentos-anteriores?origem=' + origem
        });
        return response.data;
    }

    async alterarPermissaoSustentacao(sessaoId, numeroProcesso, permiteSustentacao, permiteDestaque) {
        const response = await this.fetchConfig({
            url: `${this.configuracao.urlSessoes}${sessaoId}/processos/${numeroProcesso}/marcacao-permite-sustentacao?admiteSustentacao=${permiteSustentacao}&admiteDestaque=${permiteDestaque}`,
            method: 'POST'
        });
        return response.data;
    }

    async ajustarVoto(idSessao, numeroProcesso) {
        const url = `${this.configuracao.urlSessoes}${idSessao}/processos/${numeroProcesso}/ajustar-voto`;
        await this.fetch(url, 'POST');
    }
}

export default ProcessoApi;
